/** @typedef {{ url: string, videoSrc: string, poster: string }} ReelItem */

/** MP4s live in `frontend/public/Reels/` (served as `/Reels/N.mp4`). */
function reelMp4(n) {
  const base = process.env.PUBLIC_URL || "";
  return `${base}/Reels/${n}.mp4`;
}

/** A still from each reel (`Reels/posters/N.webp`): shown until the clip plays, or instead of
 *  it where the browser refuses to decode or autoplay video (iPhones with video previews off). */
function reelPoster(n) {
  const base = process.env.PUBLIC_URL || "";
  return `${base}/Reels/posters/${n}.webp`;
}

/**
 * Eight reels — local preview + redirect to Instagram.
 * Order matches `Reels/1.mp4` … `Reels/8.mp4` ↔ URLs below.
 */
export const REELS = /** @type {ReelItem[]} */ ([
  { url: "https://www.instagram.com/reel/DU2QXSaiADe/", videoSrc: reelMp4(1), poster: reelPoster(1) },
  { url: "https://www.instagram.com/reel/DXjeMFJiXaL/", videoSrc: reelMp4(2), poster: reelPoster(2) },
  { url: "https://www.instagram.com/reel/DUfAtLFCQA1/", videoSrc: reelMp4(3), poster: reelPoster(3) },
  { url: "https://www.instagram.com/reel/DSKZoU3DZph/", videoSrc: reelMp4(4), poster: reelPoster(4) },
  { url: "https://www.instagram.com/reel/DSAJRL0je5A/", videoSrc: reelMp4(5), poster: reelPoster(5) },
  { url: "https://www.instagram.com/reel/DRcJ27iiCcW/", videoSrc: reelMp4(6), poster: reelPoster(6) },
  { url: "https://www.instagram.com/reel/DPjGZ3HiUdL/", videoSrc: reelMp4(7), poster: reelPoster(7) },
  { url: "https://www.instagram.com/reel/DPBmPJxibUh/", videoSrc: reelMp4(8), poster: reelPoster(8) },
]);
